import { GiftWrappingConfiguration } from '../models';
import { storeApiHttp } from '../store-api';

export const GIFT_WRAPPING_CACHE_KEY = 'GIFT_WRAPPING_CONFIG';

export const getGiftWrapping = async (language?: string): Promise<GiftWrappingConfiguration> => {
  const cacheKEY = `${GIFT_WRAPPING_CACHE_KEY} ${language ?? ''}`;
  const cached = sessionStorage.getItem(cacheKEY);

  if (cached) {
    return JSON.parse(cached);
  }

  const response = await storeApiHttp.get<GiftWrappingConfiguration>(
    `/api/public-api/gift-wrapping/configuration?language=${language}`
  );

  sessionStorage.setItem(cacheKEY, JSON.stringify(response.data));

  return response.data;
};
